import "./index.scss";

import OverviewOrganizationsButton from "@Components/OrganizationSelection/OverviewOrganizationsButton";
import ReleaseNotes from "@Components/ReleaseNotes";
import AvatarAsync from "@Pages/AvatarAsync";
import { RootState } from "@Store";
import { selectIsSystemAdmin } from "@Store/AppUser/selectors";
import { updateSelectedOrganizationId } from "@Store/Organizations/actions";
import {
  selectAllowedOrganizationsList,
  selectCurrentOrgId,
  selectIsSimpleUserOfCurrentOrganization,
} from "@Store/Organizations/selectors";
import { IOrganization, OrganizationId } from "@Store/Organizations/types";
import { useAppDispatch, useAppSelector } from "@hooks";
import { Divider } from "antd";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

function OrganizationSelection() {
  const dispatch = useAppDispatch();
  const history: ReturnType<typeof useHistory> = useHistory();
  const location: ReturnType<typeof useLocation> = useLocation();

  const {
    isCurrentUserSimpleUser,
    isSystemAdmin,
    currentOrganizationId,
    organizationList,
  } = useAppSelector((state: RootState) => ({
    isCurrentUserSimpleUser: selectIsSimpleUserOfCurrentOrganization(state),
    isSystemAdmin: selectIsSystemAdmin(state),
    currentOrganizationId: selectCurrentOrgId(state),
    organizationList: selectAllowedOrganizationsList(state),
  }));

  useEffect(() => {
    if (organizationList.length > 0 && isCurrentUserSimpleUser) {
      dispatch(updateSelectedOrganizationId(organizationList[0].orgId));
    }
  }, [dispatch, isCurrentUserSimpleUser, organizationList]);

  const handleOrganizationClick = (organizationId: OrganizationId): void => {
    history.push(`/organization/${organizationId}/overview`);
  };

  const isOrganizationSelected = (orgId: OrganizationId): boolean => {
    return currentOrganizationId === orgId;
  };

  const isOrganizationsPageSelected = (): boolean =>
    location.pathname !== "/organizations";

  return (
    <>
      <div className="organization-navigation">
        {isSystemAdmin && <OverviewOrganizationsButton />}
        <div className="organization-list">
          {organizationList.map(
            ({ orgId, orgLogoUrl, orgName }: IOrganization) => (
              <div key={orgId} className="organization-button">
                <div
                  className={
                    isOrganizationSelected(orgId) &&
                    isOrganizationsPageSelected()
                      ? "inner active"
                      : "inner"
                  }
                >
                  <div
                    className={
                      isOrganizationSelected(orgId) &&
                      isOrganizationsPageSelected()
                        ? ""
                        : "notActive"
                    }
                    onClick={() => handleOrganizationClick(orgId)}
                  >
                    <AvatarAsync
                      size={45}
                      url={orgLogoUrl ?? ""}
                      shape="square"
                      placeholderText={orgName}
                    />
                  </div>
                </div>
              </div>
            )
          )}
        </div>
        <ReleaseNotes />
      </div>
      <Divider type="vertical" className="organization-navigation-divider" />
    </>
  );
}

export default OrganizationSelection;
